import Vue from 'vue';
import VueRouter from 'vue-router';
import DashboardLayout from '../layouts/DashboardLayout.vue';
import Login from '../views/auth/Login.vue';
import store from '../store';

Vue.use(VueRouter);

const routes = [
   {
      path: '/',
      component: DashboardLayout,
      redirect: 'dashboard',
      meta: {
         requiresAuth: true
      },
      children: [
         {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue')
         },
         {
            path: '/statistiques',
            name: 'statistiques',
            component: () => import(/* webpackChunkName: "about" */ '../views/Statistiques.vue')
         },
         // RUCHES ****************************
         {
            path: '/ruches',
            name: 'ruches',
            component: () => import(/* webpackChunkName: "about" */ '../views/ruches/Ruches.vue')
         },
         {
            path: '/ruches/creer',
            name: 'ruches.create',
            component: () => import(/* webpackChunkName: "about" */ '../views/ruches/CreateRuche.vue')
         },
         {
            path: '/ruches/:id/modifier',
            name: 'ruches.edit',
            component: () => import(/* webpackChunkName: "about" */ '../views/ruches/EditRuche.vue')
         },
         {
            path: '/ruches/:id/fiche',
            name: 'ruches.show',
            component: () => import(/* webpackChunkName: "about" */ '../views/ruches/ShowRuche.vue')
         },
         {
            path: '/visites',
            name: 'visites',
            component: () => import(/* webpackChunkName: "about" */ '../views/visites/Visites.vue')
         },
         {
            path: '/visites/creer',
            name: 'visites.create',
            component: () => import(/* webpackChunkName: "about" */ '../views/visites/CreateVisite.vue')
         },
         {
            path: '/visites/:id/edit',
            name: 'visites.edit',
            component: () => import(/* webpackChunkName: "about" */ '../views/visites/EditVisite.vue')
         },
         {
            path: '/parametres',
            name: 'parametres',
            component: () => import(/* webpackChunkName: "about" */ '../views/Parametres.vue')
         },
         {
            path: '/profil',
            name: 'profil',
            component: () => import(/* webpackChunkName: "about" */ '../views/Profil.vue')
         },

         {
            path: '/abonnement',
            name: 'abonnement',
            component: () => import(/* webpackChunkName: "about" */ '../views/Abonnement.vue')
         }
      ]
   },
   // auth
   {
      path: '/trop-de-ruches',
      name: 'tropDeRuches',
      meta: {
         requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "about" */ '../views/auth/TropDeRuches.vue')
   },
   {
      path: '/login',
      name: 'login',
      meta: {
         requiresVisitor: true
      },
      component: Login
   },
   {
      path: '/register',
      name: 'register',
      meta: {
         requiresVisitor: true
      },
      component: () => import(/* webpackChunkName: "about" */ '../views/auth/Register.vue')
   },
   {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "about" */ '../views/auth/Logout.vue')
   }
];

const router = new VueRouter({
   linkActiveClass: 'active',
   routes
});

router.beforeEach((to, from, next) => {
   if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.getters.loggedIn) {
         next({
            name: 'login'
         });
      } else {
         next();
      }
   } else if (to.matched.some(record => record.meta.requiresVisitor)) {
      if (store.getters.loggedIn) {
         next({
            name: 'dashboard'
         });
      } else {
         next();
      }
   } else {
      next();
   }
});

export default router;
